// extracted by mini-css-extract-plugin
module.exports = {"social__icons":"Social_social__icons__3iykA","email":"Social_email__3KPJ0","github":"Social_github__3XvGy","linkedin":"Social_linkedin__36Kya"};